export default {
  'NoData.title': 'Нет данных',
}
